<template>

  <div class="distribution-back">
    <loading v-show="showLoading"></loading>
    <div class="distribution-content" v-show="!showLoading">

      <div class="distribution-head-back">
        <img src="@/images/bg1@3x.png"/>
      </div>

      <div class="bar-title clear_both">
        <button class="fl nav_bar_left_item">
<!--          <img class="nav_item_btn" src="@/images/backIcon@2x.png" @click="$router.back(-1)" >-->
        </button>
        <div class="dist-title distribution-title">
          分享赚收益
        </div>
        <div class="dist-title distribution-rule" @click="goRule()">
          活动规则
        </div>
      </div>

      <div class="distribution-info" id="content">
        <div class="distribution-info-person">
          <img class="fl" :src="distributionInfo.partyHeadPortraitImg" v-if="distributionInfo.partyHeadPortraitImg">
          <img class="fl" src="@/images/Avatar@3x.png" v-if="!distributionInfo.partyHeadPortraitImg">
          <span class="distribution-info-name zt18 fl" style="color: #6547AA">{{distributionInfo.name}}</span>
          <span class="distribution-info-tag zt12" style="background-color:#F1B1CD;color: #6547AA;margin-left: 1rem;padding: 0.1rem 0.5rem">分享合作者</span>
          <p class="distribution-info-desc">
            <span class="distribution-info-desc-name" style="color: #6547AA">
            推荐人:{{distributionInfo.partyIdFromName}}
            </span>
            <span class="distribution-info-desc-time" style="color: #6547AA;margin-left: 1rem">
            加入时间:{{distributionInfo.joinTime}}
            </span>
          </p>
        </div>
      </div>

      <!--有收益情况-->
      <div class="distribution-money" v-if="distributionInfo.isDistributor==0">
        <div class="distribution-money-title">
          收益金额
        </div>
        <div class="distribution-money-num">
          {{distributionInfo.balancePrice}}<span>元</span>
        </div>
        <div class="distribution-money-get">
          <button @click="goApply(distributionInfo.mobileNumber,distributionInfo.availableBalance)">立即提现</button>
          <div @click="goWithdraw()">提现记录</div>
        </div>
      </div>

      <!--无收益情况-->
      <div class="distribution-money" v-if="distributionInfo.isDistributor!=0">
        <div class="distribution-money-title">
          我的收益
        </div>
        <div class="distribution-money-num">
          <div>
            还没有收益
          </div>
          <div>
            快去分享商品给好友赚钱吧
          </div>
        </div>
        <div class="distribution-money-get" >
          <button @click="showPopView=true">立即去分享</button>
        </div>
      </div>

      <div class="distribution-content-div" v-if="distributionInfo.isDistributor==0">
        <div class="distribution-content-each">
          <div class="distribution-content-each-title">
            累计收益
          </div>
          <div class="distribution-content-each-value">
            {{distributionInfo.totalPrice}} 元
          </div>
        </div>
        <div class="distribution-content-each">
          <div class="distribution-content-each-title">
            已提现
          </div>
          <div class="distribution-content-each-value">
            {{distributionInfo.withdrawPrice}} 元
          </div>
        </div>
        <div class="distribution-content-each" @click="goIncome()">
          <div class="distribution-content-each-title">
            收益明细
          </div>
          <div class="distribution-content-each-value">
            <img src="@/images/arrow3@3x.png"/>
          </div>
        </div>
        <div class="distribution-content-each" @click="goInvite()">
          <div class="distribution-content-each-title">
            我的客户
          </div>
          <div class="distribution-content-each-value">
            <img src="@/images/arrow3@3x.png"/>
          </div>
        </div>

      </div>

      <div class="distribution-shadow" v-if="distributionInfo.isDistributor==0">
      </div>

      <div class="distribution-desc">
        <div class="distribution-desc-head">
          如何轻松赚收益
        </div>
        <div class="distribution-desc-bottom">
          <div class="distribution-desc-bottom-each back-red">
            <div class="share-desc">
              分享本页或任意消费链接给好友
            </div>
          </div>
          <div class="share-icon">
            >
          </div>
          <div class="distribution-desc-bottom-each back-yellow">
            <div class="share-desc">
              好友打开链接    注册成新会员
            </div>
          </div>
          <div class="share-icon">
            >
          </div>
          <div class="distribution-desc-bottom-each back-pink">
            <div class="share-desc">
              好友每次完成购买，您都可赚收益
            </div>
          </div>
        </div>
        <div class="distribution-desc-share">
          <button @click="showPopView=true">立即分享</button>
        </div>
        <div class="distribution-desc-icon">
          <img src="@/images/Graphics1@3X.png">
        </div>
      </div>

    </div>


    <van-overlay :show="showPopView" @click="showPopView = false" >
      <div class="ovh fr tr" style="margin-right: 4rem;margin-top: 1rem">
        <img class="fr" style="width: 2rem;margin-left: 1rem" src="@/images/share.png">
        <p class="zt16 fr white ovh tr">点击菜单分享给好友，立即赚取收益</p>
      </div>
    </van-overlay>

  </div>

</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo,shareUrl,severUrl,shareOnlineUrl,wxUrl } from '@/router/Constant'
  import { login,getDistributionDetail,getWeixinShare} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog,Popup,Overlay} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie,setMiniProgramShare } from '@/utils/mUtil';

  export default {
    name: "distributionMenu",
    data(){
      return {
        showLoading:true,
        token:getStore("externalLoginKey"),
        distributionInfo:{},
        showPopView: false,
      }
    },
    mounted(){
      this.initData()
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
      document.documentElement.scrollTop = 0
      window.addEventListener('scroll',this.handleScroll,true)
    },

    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Overlay.name]: Overlay,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      [Dialog.Component.name]: Dialog.Component,
      [Popup.name]:Popup
    },

    methods:{
      showPopup() {
        this.show = true;
      },

      async initData() {
        this.showLoading = false
        if (getStore('islogIn') != 'true') {
          Dialog.confirm({
            title: '确认登陆',
            message: '您当前还未登陆，是否登录？'
          }).then(() => {
            this.login()
          }).catch(() => {
            // on cancel
          });
        } else{
          this.getDetail()
        }
      },

      login (){
        login({USERNAME:loginInfo.userName,PASSWORD:loginInfo.password})
          .then(res => {
            console.log(res)
            if (res._TOKEN_){
              setStore('externalLoginKey',res._TOKEN_)
              setStore('islogIn',true)
              Toast("用户已经模拟登录")
              this.token = res._TOKEN_
              this.getDetail()
            } else {
              Toast({message:"用户未登录"})
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      getDetail:function(){
        let param = {
          externalLoginKey: this.token,
        }
        getDistributionDetail(param)
          .then(res => {
            console.log(res);
            if(!res._ERROR_MESSAGE_){
              //成功
              this.distributionInfo = res.resultMap
              // this.getConfig()

              setMiniProgramShare("您的好友" + this.distributionInfo.name + "邀请您成为天使俱乐部会员",this.distributionInfo.partyHeadPortraitImg,wxUrl+encodeURIComponent(shareOnlineUrl+'distributionMenu')+'&partyId='+this.distributionInfo.partyId)
            }else{
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //跳转至分销规则页面
      goRule:function () {
        this.$router.push({name:'distributionRule'})
      },

      //跳转至我的客户页面
      goInvite:function () {
        this.$router.push({name:'distributionInvite'})
      },

      //跳转至我的提现记录
      goWithdraw:function () {
        this.$router.push({name:'distributionWithdraw'})
      },

      //跳转至我的收益明细
      goIncome:function () {
        this.$router.push({name:'distributionIncome'})
      },

      //跳转至提现页面
      goApply:function (phone,price) {
        this.$router.push({name:'distributionApply',query:{phone:phone,price:price}})
      },

      //页面滚动事件
      // handleScroll:function (e) {
        // let scrollY = document.documentElement.scrollTop
        // if(document.querySelector('#content')!=undefined){
        //   if(scrollY>20){
        //     document.querySelector('.bar-title').setAttribute('style','background-color:white')
        //   }else{
        //     document.querySelector('.bar-title').setAttribute('style','background-color:transparent')
        //   }
        // }

      // },

      // //页面离开时销毁监听事件
      // destroyed(){
      //   window.removeEventListener('scroll', this.handleScroll);
      // },

      //获取当前分享的内容
      getConfig:function(){
        let param;
        var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          //这个是安卓操作系统
          param = 'android'
        }
        if (isIOS) {
          //这个是ios操作系统
          param = 'ios'
        }
        let paramList = {
          url: window.location.href,
          os:param
        }
        getWeixinShare(paramList).then(res => {
          console.log(res)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.shareMap.appId, // 必填，公众号的唯一标识
            timestamp: res.shareMap.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.shareMap.nonceStr, // 必填，生成签名的随机串
            signature: res.shareMap.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
          });

          var thisBlock = this
          wx.ready(function(){
            wx.updateAppMessageShareData({
              title: "您的好友" + thisBlock.distributionInfo.name + "邀请您成为天使俱乐部会员", // 分享标题
              desc: '点击加入', // 分享描述
              link: severUrl+'/shareDistribution.html?/home?partyId='+thisBlock.distributionInfo.partyId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: thisBlock.distributionInfo.partyHeadPortraitImg, // 分享图标
              success: function () {
              },error:function () {
              }
            })

            //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: "您的好友" + thisBlock.distributionInfo.name + "邀请您成为天使俱乐部会员",
              desc: '点击加入',
              link: severUrl+'/shareDistribution.html?/home?partyId='+thisBlock.distributionInfo.partyId,
              imgUrl: thisBlock.distributionInfo.partyHeadPortraitImg,
              success: function () {
              },error:function () {
              }
            })
          });

        })
      }

    }
  }
</script>

<style scoped>

  .distribution-head-back{
    width:100%;
    height: 13.6875rem;
  }
  .distribution-head-back img{
    width:100%;
    height: 100%;
  }
  .distribution-back{
    width:100%;
  }
  .bar-title {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    position: absolute;
    top:0;
    z-index: 1;
    width: 100%;
    height: 2rem;
    line-height: 2rem;
    background-color: transparent;
  }
  .nav_bar_left_item {
    padding-top: 0.3rem;
    width:2.5rem;
  }
  .nav_item_btn {
    width: 1.25rem;
    height: 1.25rem;
  }
  .dist-title{
    text-align: center;
    font-size: 1rem;
    color:#333312;
    display: inline-block;
    vertical-align: top;
  }
  .distribution-title{
    font-size:1rem;
    color:#333333;
    width:16.8rem;
  }
  .distribution-rule{
    font-size: 0.8125rem;
    color:#333333;
  }
  .distribution-info{
    position: absolute;
    top: 3rem;
    width:100%;
  }
  .distribution-info-person{
    width:21.4375rem;
    margin: 0 auto 0.25rem;
  }
  .distribution-info-person img{
    width:3.5rem;
    height: 3.5rem;
    margin-left: 1.3rem;
    border-radius: 2rem;
    margin-right: 1rem;
  }
  .distribution-info-person span{
    color:white;
  }
  .distribution-info-name{
    margin-bottom: 0.3rem;
  }
  .distribution-info-tag{
    width:5rem;
    height: 1.40625rem;
    border-radius: 0.625rem;
    border: 1px solid white;
    text-align: center;
    line-height: 1.40625rem;
  }
  .distribution-info-desc{
    font-size:0.71825rem;
  }
  .distribution-money{
    width: 21.4375rem;
    margin-left: 1rem;
    margin-top: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 0.625rem #ddd;
    height: 9.375rem;
  }
  .distribution-money-title{
    width:100%;
    text-align: center;
    color:#333;
    font-size: 0.90625rem;
    padding-top: 0.875rem;
  }
  .distribution-money-num{
    width:100%;
    margin: 0.5rem auto 0;
    text-align: center;
    color:#D8598E;
    font-size: 1.875rem;
  }
  .distribution-money-num span{
    font-size: 0.84375rem;
  }
  .distribution-money-num div{
    font-size: 0.84375rem;
    width:100%;
    text-align: center;
  }
  .distribution-money-get{
    margin-top: 0.875rem;
  }
  .distribution-money-get button{
    width:10.3125rem;
    height: 2.5rem;
    line-height: 2.5rem;
    display: inline-block;
    vertical-align: top;
    color:white;
    font-size: 0.8125rem;
    text-align: center;
    background-color: #EB84AB;
    border-radius: 1.25rem;
    padding: 0;
    margin-left: 5rem;
  }
  .distribution-money-get div{
    font-size: 0.75rem;
    color:#666;
    margin-left: 1rem;
    display: inline-block;
    vertical-align: bottom;
  }
  .distribution-shadow{
    width:100%;
    background-color: #E7E7E7;
    height: 0.625rem;
  }
  .distribution-content-div{
    width:100%;
    margin-top: 1.5rem;
  }
  .distribution-content-each{
    width:21.4375rem;
    margin: 0 auto;
    border-bottom: 1px solid #E7E7E7;
    height: 3.34375rem;
    line-height: 3.34375rem;
    clear: both;
  }
  .distribution-content-each div{
    display: inline-block;
    vertical-align: top;
  }
  .distribution-content-each-title{
    font-size: 0.875rem;
    color:#33312E;
  }
  .distribution-content-each-value{
    font-size: 0.8125rem;
    color:#EB84AB;
    float: right;
  }
  .distribution-content-each-value img{
    width:1.375rem;
    height: 1.375rem;
    margin-top: 1rem;
  }
  .distribution-desc{
    width:100%;
    margin-top: 0.625rem;
  }
  .distribution-desc-head{
    width:21.4375rem;
    margin: 0 auto;
    border-bottom: 1px solid #E7E7E7;
    height: 3.40625rem;
    line-height: 3.40625rem;
    color:#33312E;
    font-size: 0.90625rem;
  }
  .distribution-desc-bottom{
    width: 21.4375rem;
    margin: 0.9375rem auto 2rem;
    height: 4.375rem;
  }
  .distribution-desc-bottom-each{
    color:white;
    font-size:0.8125rem;
    width:6.5625rem;
    height: 4.375rem;
    border-radius: 0.625rem;
    text-align: center;
    float: left;
  }
  .share-icon{
    float: left;
    width: 0.875rem;
    height: 4.375rem;
    line-height: 4.375rem;
    font-size: 0.75rem;
    color:#E7E7E7;
    text-align: center;
  }
  .share-desc{
    margin: 0.5rem;
    line-height: 1.25rem;
  }
  .back-red{
    background-color: #EB84AB;
  }
  .back-yellow{
    background-color: #B6A9CD;
  }
  .back-pink{
    background-color: #B7DBF3;
  }
  .distribution-desc-share{
    width:100%;
    text-align: center;
  }
  .distribution-desc-share button{
    background-color: #EB84AB;
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    width: 12rem;
    border-radius: 1.5rem;
    margin: 0.5rem 5rem;
    color:white;
  }
  .distribution-desc-icon{
    width:12rem;
    height: 3.21875rem;
    margin-left: 5.09375rem;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
  .distribution-desc-icon img{
    width:100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/mine/distributionMenu.vue